import _ from "lodash";
import { computed } from "vue";

export function useGetAreasFromStages(stages: Stage[]) {
    return computed(() => {
        return _.uniqBy(
            stages.map((stage) => stage.quest.area),
            "id",
        );
    });
}

export function useGetQuestsFromStagesByArea(stages: Stage[], area: Area) {
    return _.uniqBy(
        stages
            .filter((stage) => stage.quest.area.id === area.id)
            .map((stage) => stage.quest),
        "quest.id",
    );
}
